#import "./audience-membership-fragment.graphql"

fragment ContactAudienceMeberships on Contact {
    id
    name
    hasUnsubscribedFromAllAudiences
    unsubscribedFromAllAudiencesSource
    hasHardBounced
    preferenceCenterLink
    emailAddresses {
        all {
            id
            name
        }
    }
    audienceMemberships {
        ...AudienceMembership
    }
    audienceMembershipsSubscribed {
        ...AudienceMembership
    }
    audienceMembershipsUnsubscribed {
        ...AudienceMembership
    }
}
